import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {RaisedButton, Dialog, MenuItem, IconButton} from "material-ui";

import { changePort } from 'actions/regions/ports';
import {Field, formValueSelector, FieldArray, reduxForm} from "redux-form";
import {TextField, SelectField} from "redux-form-material-ui";

import Emails from './Emails';
import Phones from './Phones';

import portActivities from 'data/portActivities';
import { length, required, numericality} from 'redux-form-validators';

import { formName } from 'data/formNames';

import ControlPointIcon from 'material-ui/svg-icons/image/control-point';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';

const styles = {
    dialog: {
        contentStyle: { width: '843px', padding: '20px' },
    },
    textField: {
        floatingLabelStyle: {
            fontSize: '12px'
        }
    },
    btn: {
        labelStyle: {color: '#fff'},
    }
};

const emptyLimitation = {
    maxDraught: undefined,
    maxBeam: undefined,
    maxLOA: undefined,
    maxDWT: undefined,
    channelDepth: undefined,
    anchorageDepth: undefined,
};

class AddServiceProvider extends React.Component {
    constructor(props) {
        super(props);

        this.onRequestClose = this.onRequestClose.bind(this);
    }

    onRequestClose() {
        this.props.fields.pop();
        this.props.toggle();
    }

    render() {
        const { open, field, toggle, serviceProvider } = this.props;

        return (
            <Dialog
                open={open}
                contentStyle={styles.dialog.contentStyle}
                onRequestClose={this.onRequestClose}
                paperClassName={'dialog-service-provider'}
                bodyStyle={{ overflowY: 'auto' }}
            >
                <Fragment>
                    <form>
                        <div className={'title'}>
                            Add Service Provider: <br />
                            Marine equipment & spare parts
                        </div>

                        <div className="row">
                            <div className="col-xs-6">
                                <Field
                                    component={SelectField}
                                    name={`${field}.activities`}
                                    floatingLabelText='Activities'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    multiple={true}
                                    value={serviceProvider && serviceProvider.activities}
                                    fullWidth
                                    autoWidth
                                    validate={required()}
                                >
                                    {
                                        portActivities.map((portActivity, index) => {
                                            return (
                                                <MenuItem
                                                    key={index}
                                                    value={portActivity}
                                                    primaryText={portActivity}
                                                />
                                            )
                                        })
                                    }
                                </Field>
                            </div>
                            <div className="col-xs-6">
                                <Field
                                    component={TextField}
                                    name={`${field}.name`}
                                    floatingLabelText='Company name'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    fullWidth
                                    validate={[required(), length({ min: 3, max: 266})]}
                                />
                            </div>
                        </div>
                        {
                            serviceProvider && serviceProvider.activities && serviceProvider.activities.includes('Stevedoring Company') &&
                                <FieldArray
                                    name={`${field}.limitations`}
                                    component={renderPortLimitations}
                                    styles={styles}
                                />
                        }
                        <div className="row">
                            <div className="col-xs-6">
                                <FieldArray
                                    name={`${field}.emails`}
                                    component={ Emails }
                                />
                            </div>
                            <div className="col-xs-6">
                                <FieldArray
                                    name={`${field}.phones`}
                                    component={ Phones }
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xs-6">
                                <Field
                                    component={TextField}
                                    name={`${field}.address`}
                                    floatingLabelText='Address'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    fullWidth
                                    validate={required()}
                                />
                            </div>
                            <div className="col-xs-6">
                                <Field
                                    component={TextField}
                                    name={`${field}.PIC`}
                                    floatingLabelText='PIC'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    fullWidth
                                    validate={required()}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xs-12">
                                <RaisedButton
                                    label="Cancel"
                                    primary
                                    onClick={this.onRequestClose}
                                />

                                <RaisedButton
                                    label="Add"
                                    backgroundColor={'#7FC931'}
                                    labelStyle={styles.btn.labelStyle}
                                    onClick={this.props.handleSubmit((submit) => {
                                        toggle();
                                        this.props.changePort(submit);
                                    })}
                                />
                            </div>
                        </div>
                    </form>
                </Fragment>
            </Dialog>
        );
    }
}

function renderPortLimitations({fields, styles}) {
    return (
        <div>
            {
                fields.map((field, limitationIndex) => {
                    return (
                        <div className="row" key={`limitation_${limitationIndex}`}>
                            <div className="col-xs-12">
                                <Field
                                    component={TextField}
                                    name={`${field}.berth`}
                                    floatingLabelText='Berth'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    style={{ width: '14%' }}
                                />
                                <Field
                                    component={TextField}
                                    name={`${field}.maxDraught`}
                                    floatingLabelText='Max draft, m:'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    style={{ width: '14%', marginLeft: '10px' }}
                                    validate={[numericality({ '>=': 0, '<=': 100, allowBlank: true })]}
                                />
                                <Field
                                    component={TextField}
                                    name={`${field}.maxBeam`}
                                    floatingLabelText='Max beam, m:'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    style={{ width: '14%', marginLeft: '10px' }}
                                    validate={[ numericality({ '>=': 0, '<=': 100, allowBlank: true })]}
                                />
                                <Field
                                    component={TextField}
                                    name={`${field}.maxLOA`}
                                    floatingLabelText='Max LOA, m:'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    style={{ width: '14%', marginLeft: '10px' }}
                                    validate={[ numericality({ '>=': 0, '<=': 1000, allowBlank: true })]}
                                />
                                <Field
                                    component={TextField}
                                    name={`${field}.maxDWT`}
                                    floatingLabelText='Max DWT, m:'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    style={{ width: '14%', marginLeft: '10px' }}
                                    validate={[ numericality({ '>=': 0, '<=': 1000000, allowBlank: true })]}
                                />
                                <Field
                                    component={TextField}
                                    name={`${field}.channelDepth`}
                                    floatingLabelText='Channel Depth, m:'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    style={{ width: '14%', marginLeft: '10px' }}
                                    validate={[ numericality({ '>=': 0, '<=': 100, allowBlank: true })]}
                                />
                                <div className='center-xs' style={{ display: 'inline-flex', width: '8%' }}>
                                    {
                                        limitationIndex === 0 ?
                                            <IconButton
                                                iconStyle={styles.icon}
                                                onClick={() => fields.push(emptyLimitation)}>
                                                <ControlPointIcon />
                                            </IconButton>
                                        :
                                            <IconButton
                                                iconStyle={styles.icon}
                                                onClick={() => fields.remove(limitationIndex)}>
                                                <ContentRemoveIcon />
                                            </IconButton>
                                    }
                                </div>
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
}

AddServiceProvider.propTypes = {};

AddServiceProvider.defaultProps = {};

const FormAddServiceProvider = reduxForm({
    form: formName.portUpdateAddServiceProvider,
    enableReinitialize: true,
})(AddServiceProvider);

const selector = formValueSelector(formName.portUpdate);
const selectorAddServiceProvider = formValueSelector(formName.portUpdateAddServiceProvider);
export default connect(
    (state, ownProps) => {
        return {
            initialValues: { serviceProviders: selector(state, 'serviceProviders') },
            serviceProvider: selectorAddServiceProvider(state, ownProps.field),
        };
    },
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(FormAddServiceProvider);


// WEBPACK FOOTER //
// ./app/components/Regions/Port/ServiceProviders/AddServiceProvider.jsx